module.exports = __webpack_public_path__ + "static/media/pr.452764e1.svg";